<template>
  <div class="un-authorized-layout row mx-0">
    <template v-if="isSignup && isYektanetPlt">
      <div class="col-12 col-md-6 col-xl-5">
        <slot />
      </div>
      <div
        class="d-none d-md-block col-md-6 col-xl-7 h-100"
        style="background-color: #f5f5f5"
      >
        <NewDesktopServicePromotion
          v-if="!['yektanet-rubika-adv', 'yektanet-sheypoor-adv', 'yektanet-technolife-adv', 'yektanet-retail-basalam-adv'].includes(getParam('account_custom_type'))"
        />
      </div>
    </template>
    <template v-else-if="isSignup && isLeadPlt">
      <div class="yn-logo">
        <img :src="leadLogo" />
      </div>

      <div class="d-lg-none w-100 px-4 pb-4">
        <h1 class="page-title text-right">ثبت‌نام</h1>

        <div class="already-have-account">
          <span style="color: #444">قبلا ثبت‌نام کرده‌اید؟</span>
          <a :href="loginUrl"> ورود به حساب کاربری </a>
        </div>
      </div>

      <div class="d-lg-none col-12" style="background-color: #fafafa">
        <LeadMobileServicePromotion />
      </div>

      <div class="col-12 col-lg-5">
        <slot />
      </div>

      <div
        class="d-none d-lg-block col-lg-7 h-100"
        style="background-color: #f5f5f5"
      >
        <LeadDesktopServicePromotion />
      </div>
    </template>
    <template v-else>
      <div
        v-if="!['yektanet-rubika-adv', 'yektanet-sheypoor-adv', 'yektanet-technolife-adv', 'yektanet-retail-basalam-adv'].includes(getParam('account_custom_type'))"
        class="d-none d-md-block col-md-5 col-xl-4 border-start overflow-hidden"
        style="background-color: #f5f5f5"
      >
        <desktop-service-promotion :utm-campaign="utmCampaign" />
      </div>
      <div
        class="col-12 col-md-7 col-xl-8 d-flex flex-column pr-xl-big py-5 py-md-0 position-relative"
      >
        <mobile-service-promotion
          v-if="!['yektanet-rubika-adv', 'yektanet-sheypoor-adv', 'yektanet-technolife-adv', 'yektanet-retail-basalam-adv'].includes(getParam('account_custom_type'))"
          :utm-campaign="utmCampaign"
        />
        <slot />

        <div class="mb-auto mx-auto w-100" :style="{ maxWidth }">
          <account-support
            :email="email"
            :utm-campaign="utmCampaign"
          ></account-support>
        </div>
      </div>
    </template>

    <server-notifications />
  </div>
</template>

<script>
import DesktopServicePromotion from "~/components/ServicePromotion/DesktopServicePromotion.vue";
import NewDesktopServicePromotion from "~/components/ServicePromotion/NewDesktopServicePromotion.vue";
import LeadDesktopServicePromotion from "~/components/ServicePromotion/LeadDesktopServicePromotion.vue";
import LeadMobileServicePromotion from "~/components/ServicePromotion/LeadMobileServicePromotion.vue";
import MobileServicePromotion from "~/components/ServicePromotion/MobileServicePromotion.vue";
import AccountSupport from "~/components/AccountSupport.vue";
import ServerNotifications from "~/components/ServerNotifications.vue";

import { getParam } from "~/utils";

export default {
  components: {
    DesktopServicePromotion,
    MobileServicePromotion,
    AccountSupport,
    ServerNotifications,
    NewDesktopServicePromotion,
    LeadDesktopServicePromotion,
    LeadMobileServicePromotion,
  },
  data: () => ({
    pltService: "",
    isYektanetPlt: false,
    isLeadPlt: serverData.isLeadPanelSignup,
    platformLogos,
    urls: serverData.urls,
    leadLogo: signupBnrs.leadLogo,
  }),
  computed: {
    loginUrl() {
      return this.urls.login + window.location.search;
    },
  },
  methods: {
    getParam,
  },
  mounted() {
    this.isYektanetPlt = ![
      "triboon",
      "najva",
      "jaryan",
      "adivery",
      "novinhub",
      "chavosh",
      "lead",
    ].includes(getParam("plt"));

    this.$nextTick(() => {
      document.querySelector(".un-authorized-layout").style.visibility =
        "unset";
    });
  },
  props: {
    utmCampaign: {
      type: String,
      required: true,
    },
    maxWidth: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      default: "sales@yektanet.ir",
    },
    isSignup: Boolean,
  },
};
</script>

<style>
.already-have-account {
  font-size: 12px;
  font-weight: 500;
  text-align: right;

  a {
    color: #00948b;
    text-decoration: none;
  }
}

.yn-logo {
  display: flex;
  width: 100%;
  justify-content: center;
  padding: 2rem;
  position: relative;
  img {
    height: 32px;
  }
}
@media screen and (min-width: 992px) {
  .yn-logo {
    display: block;
    width: max-content;
    padding: 0;
    position: fixed;
    top: 2rem;
    right: 2rem;
    height: 32px;
    z-index: 1;
  }
}

.change-lang-btn {
  position: absolute;
  top: 10px;
  right: 10px;
}

.un-authorized-layout {
  visibility: hidden;
}
@media screen and (min-width: 992px) {
  .un-authorized-layout {
    overflow: hidden;
    height: 100vh !important;
  }
}

.intro-logo {
  width: 100%;
  margin: 0 auto;
  padding-top: 80px;
  padding-bottom: 20px;
}
</style>
